import { render, staticRenderFns } from "./PassengerInfo.vue?vue&type=template&id=3ea0a798&scoped=true&"
import script from "./PassengerInfo.vue?vue&type=script&lang=js&"
export * from "./PassengerInfo.vue?vue&type=script&lang=js&"
import style0 from "./PassengerInfo.vue?vue&type=style&index=0&id=3ea0a798&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea0a798",
  null
  
)

export default component.exports